import { Pipe, PipeTransform } from '@angular/core';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';

// DateFns Format: https://date-fns.org/docs/format

@Pipe({
  name: 'displayDate',
})
export class DisplayDatePipe implements PipeTransform {
  // date should come in db-day-date format (yyyy-MM-dd)
  transform(date?: Date, dateFnsFormat?: string) {
    if (!date) return '';
    return format(date, dateFnsFormat || 'dd.MM.yyyy', { locale: de });
  }
}
